import React from "react";
import Footer from "../components/footer";
import Header from "../components/header";
import ProblemList from "../components/problemset";

const ProblemSet = () => {
  return (
    <>
      <Header />
      <ProblemList />
      <Footer />
    </>
  );
};

export default ProblemSet;
